import { AccountType } from "@/modules/account/common/enum";
import { AccountDetails, Accounts, ClosedAccounts } from "@/modules/account/components";
import { getAccountTabItems } from "@/modules/account/helpers";
import { PageHeader, ScrollableTab } from "@/shared/components";
import { useAppDispatch, useAppSelector } from "@/shared/hooks";
import { setAccountActiveTab, setActiveAccountId } from "@/shared/state/common";
import { Heading } from "@ab.uitools/ui-library/components/Heading";
import { type ReactNode, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type ITemplate = {
  [key in AccountType]: ReactNode;
};

export const AccountsPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const activeItem = useAppSelector(state => state.common);

  const [selectedTab, setSelectedTab] = useState<string>(activeItem?.accountActiveTab || AccountType.SettlementAccount);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const closeAccountDetails = () => {
    setIsOpen(false);
    dispatch(setAccountActiveTab(null));
    dispatch(setActiveAccountId(null));
  };

  const template: ITemplate = {
    [AccountType.SettlementAccount]: <Accounts
      accountId={activeItem?.accountId}
    />,
    [AccountType.CardAccount]: <Accounts
      accountId={activeItem?.accountId}
      type={AccountType.CardAccount}
    />,
    [AccountType.ClosedAccount]: <ClosedAccounts limit={1000}/>,
  };

  useEffect(() => {
    if (activeItem?.accountId) {
      setIsOpen(true);
    }
  }, [activeItem]);

  return (
    <>
      <div className="full-width page-container">
        <PageHeader/>
        <div className="full-width flexbox justify-content--center h-fit-content page-body">
          <div className="widget-wrapper">
            <div className="full-width mb-20">
              <Heading className="content-title" size="xsmall" weight="bolder">
                {t("accounts.title")}
              </Heading>
            </div>
            <ScrollableTab
              activeTab={activeItem.accountActiveTab}
              tabEnum={AccountType}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              getTabItems={getAccountTabItems}
            />
            {template[selectedTab as AccountType]}
          </div>
        </div>
      </div>
      {isOpen && (
        <AccountDetails
          isOpen={isOpen}
          accountId={`${activeItem?.accountId}`}
          onClose={closeAccountDetails}
        />
      )}
    </>
  );
};
